import { clipEndBar, timelineBars } from '@/audio/clipTiming';
import { findPasteBar } from './pastePlacement';
const EPS = 1e-6;
export function copyPhraseBars(clip, bpm, mode = 'auto') {
  if (mode === '4' || mode === '8') return Number(mode);
  const length = timelineBars(clip, bpm);
  return length <= 4 + EPS ? 4 : length <= 8 + EPS ? 8 : Math.ceil((length - EPS) / 8) * 8;
}
export function nextCopyBar(clip, bpm, mode = 'auto') {
  const step = copyPhraseBars(clip, bpm, mode);
  return Math.ceil((clipEndBar(clip, bpm) - EPS) / step) * step;
}
export function findCopyBar({ tracks, trackId, clip, bpm, mode = 'auto', maxBars }) {
  return findPasteBar({ tracks, items: [{ trackId, clip, relativeOffset: 0 }],
    desiredBar: nextCopyBar(clip, bpm, mode), span: timelineBars(clip, bpm), bpm,
    maxBars, step: copyPhraseBars(clip, bpm, mode) });
}
export function dragBar(startBar, deltaPixels, pxPerBar, fine = false, maxStart = Infinity, snap = null) {
  const step = snap === null ? (fine ? 0.25 : 1) : (fine ? 0 : Number(snap));
  return Math.max(0, Math.min(maxStart, (step ? Math.round((startBar + deltaPixels / pxPerBar) / step) * step : startBar + deltaPixels / pxPerBar)));
}
